<template>
	<!-- App -->
  <div class="page">

    <!-- Affichage sur petit écran -->
      <div class="showSmallScreenOnly" v-bind:class="colorBottomButton">
        <f7-fab v-if="this.service !== 'Direct Debit'" class="leftfav button-fab bottomButton floatingButtonToolbarBlank" href="/attachments/import/">
          <f7-icon f7="bullet_list"></f7-icon>
        </f7-fab>
        <f7-fab v-if="this.service === 'Direct Debit'" class="leftfav bottomButton floatingButtonToolbarBlank" href="/attachments/import/">
          <f7-icon f7="bullet_list"></f7-icon>
        </f7-fab>
        <f7-fab v-if="this.service === 'Payments'" class="leftfav3 bottomButton floatingButtonToolbarBlank" href="/attachments/createInvoice//">
          <f7-icon f7="add"></f7-icon>
        </f7-fab>
        <f7-fab v-if="this.service === 'Direct Payments'" class="leftfav3 bottomButton floatingButtonToolbarBlank" href="/attachments/createRefund/">
          <f7-icon f7="add"></f7-icon>
        </f7-fab>
        <f7-fab class="leftfav2 button-fab bottomButton floatingButtonToolbarBlank" @click="extractCSV()">
          <f7-icon f7="document_text"></f7-icon>
        </f7-fab>
      </div>
    <div class="page-content">

  		<page-nav-bar currentServiceName="MoneyRoad" popoverName=".popoverAttachments" :subNavTitle="attachmentsPage_AttachmentsList" :menuAccess="true"></page-nav-bar>
      <!-- Affichage sur grand écran de bureau -->

      <div class="row rowBackgroundImage showLargeScreenOnly" v-bind:class="colorBottomButton">
        <div class="row rowSearchBar">
          <div v-if="this.service !== 'Direct Debit'" class="firstButtonMarginLeft showLargeScreenOnly">
            <a href="/attachments/import/" class="new-button-color">
              <button class="new-button  milkyBlock boxRequest">
                    <f7-icon f7="bullet_list"></f7-icon>
                    <span>{{ $t('common.import_item', {itemname: this.$i18n.t(this.$engine.services.getAttachmentName(this.$engine.user.currentService.id))}) }}</span>
              </button>
            </a>
          </div>
          <div v-if="this.service === 'Direct Debit'" class=" firstButtonMarginLeft showLargeScreenOnly">
            <a href="/attachments/import/" class="new-button-color">
              <button class="new-button milkyBlock boxRequest" >
                  <f7-icon f7="bullet_list"></f7-icon>
                  <span>{{ $t('attachments.import_attach') }}</span>
              </button>
            </a>
          </div>
          <div v-if="this.service === 'Payments'" class="showLargeScreenOnly">
            <a href="/attachments/createInvoice//" class="new-button-color">
              <button class="new-button milkyBlock boxRequest">
                  <f7-icon f7="add"></f7-icon>
                  <span>{{ $t('attachments.create_invoice') }}</span>
              </button>
            </a>
          </div>
          <div v-if="this.service === 'Direct Payments'" class="showLargeScreenOnly">
            <a href="/attachments/createRefund/" class="new-button-color">
              <button class="new-button milkyBlock boxRequest" >
                  <f7-icon f7="add"></f7-icon>
                  <span>{{ $t('attachments.create_refund') }}</span>
              </button>
            </a>
          </div>
          <div>
            <button class="new-button milkyBlock boxRequest" @click="extractCSV()">
              <f7-icon f7="document_text"></f7-icon>
              <span>{{ $t('common.extract_csv') }}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
            <f7-searchbar class="search"
              search-list="#attachment-list"
              cancel-link="Cancel"
              :placeholder="attachmentsPage_SearchAttachments"
              :clear-button="true"
              :virtual-init="true"
              @searchbar:search="onSearch"
              @searchbar:clear="onClear">
            </f7-searchbar>
          </div>
         </div>
  		<div class="layoutSubtitle"/>
      <cm-attachments-list :service="service" v-bind:Attachments="Attachments"></cm-attachments-list>
      <cm-pagination
        :firstIndex="paginationObject.firstIndex"
        :maxResultsByPage="paginationObject.maxResults"
        :nbResultsTotal="paginationObject.nbResultsTotal"
        :refreshEvent="paginationObject.refresh"
        >
      </cm-pagination>

      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import attachmentsList from './CMAttachmentsPage/CMAttachmentsList.vue'
import attachmentFilter from '@/components/common/CMAttachmentFilter.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'
import pagination from '@/components/common/pagination.vue'
import moment from 'moment'

export default {
  name: 'Attachments',
  components: {
    'cm-attachments-list': attachmentsList,
    'cm-attachment-filter': attachmentFilter,
    'cm-pagination': pagination,
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      isSmartphone: false,
      Attachments: [],
      attachmentsSelected: [],
      filterBy: '',
      service: '',
      paginationObject: {}
    }
  },
  created: function () {
    this.attachmentsPage_AttachmentsList = this.$i18n.t('attachments.attachments_list')
    this.attachmentsPage_SearchAttachments = this.$i18n.t('attachments.search_attchmnts')
    let that = this
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 10
    this.paginationObject['nbResultsTotal'] = 0
    this.paginationObject['refresh'] = 'refresh-cache-attachments-paging'
    /* Turn off all buses events */
    // this.$bus.$off('inbox-filtered')
    this.$bus.$off('sendbox-filtered')
    // this.$bus.$off('refresh-cache-service')
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    // this.$bus.$off('refresh-cache-attachments-view')
    this.$bus.$off('refresh-cache-account-members')
    this.$bus.$off('refresh-inbox-list-cache')
    this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage

    this.$bus.$off('refresh-cache-attachments-paging')
    this.$bus.$on('refresh-cache-attachments-paging', (index) => {
      that.getAttachmentsPagination(index)
    })
    this.service = this.$engine.user.currentService.name
    this.getAttachmentsPagination()

    // TODO: event taphold
    that.$$(document).on('taphold', '.attachmentTaphold', function () {
      if (that.attachmentsSelected.includes(that.$$(this).data('item')) === false) {
        that.attachmentsSelected.push(that.$$(this).data('item'))
        that.$$(this).addClass('listItemSelected')
      } else if (that.attachmentsSelected.includes(that.$$(this).data('item')) === true) {
        let index = that.attachmentsSelected.indexOf(that.$$(this).data('item'))
        if (index > -1) {
          that.attachmentsSelected.splice(index, 1)
        }
        that.$$(this).removeClass('listItemSelected')
      }
    })
  },
  methods: {
    onSearch: function (query, found) {
      this.filterBy = query
      this.getAttachmentsPagination()
    },
    getLabelType: function (type) {
      if (type === '0') {
        return ['Invoice', this.$i18n.t('attachments.invce')]
      } else if (type === '1') {
        return ['Refund', this.$i18n.t('attachments.refnd')]
      } else {
        return type
      }
    },
    orderAttachments: function (response) {
      var attachmentList = {}
      let cloudFiles = response.data.docs
      let nbElement = 0
      this.paginationObject.nbResults = 0
      for (var j = 0; j < cloudFiles.length; j++) {
        var firstLetter = cloudFiles[j].name.substr(0, 1).toUpperCase()
        var type = this.getLabelType(cloudFiles[j].type)
        if (cloudFiles[j].name.toLowerCase().includes(this.filterBy.toLowerCase()) &&
        ((this.service === 'Payments' && type[0] === 'Invoice') ||
        (this.service === 'Direct Payments' && type[0] === 'Refund') ||
        this.service === 'Direct Debit')) {
          nbElement++
          if (this.paginationObject.firstIndex <= nbElement && nbElement < (this.paginationObject.firstIndex + this.paginationObject.maxResults)) {
            if (!attachmentList.hasOwnProperty(firstLetter)) {
              attachmentList[firstLetter] = []
            }
            this.paginationObject.nbResults++
            attachmentList[firstLetter].push({name: cloudFiles[j].name, type: type[1], id: cloudFiles[j].id})
            attachmentList[firstLetter].sort()
          }
        }
      }
      this.paginationObject.nbResultsTotal = nbElement
      return this.orderKeys(attachmentList)
    },
    getAttachmentsPagination: function (index = 1) {
      let that = this
      this.paginationObject.firstIndex = index

      let params = {
        idAcct: this.$engine.user.get().id
        // 'firstIndex': this.paginationObject.firstIndex,
        // 'maxResults': this.paginationObject.maxResults
      }

      // smartphoneStorage vaut true si on est sur petit écran, false sinon
      if (this.$engine.services.directPayments.filter.smartphoneStorage) {
        this.isSmartphone = true
      }
      that.$engine.attachments.getRefresh(params).then(response => {
        this.Attachments = this.orderAttachments(response)
        // this.$bus.on => src/components/common/pagination.vue
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    },
    onClear: function () {
      this.filterBy = ''
    },
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    OpenFormsPage () {
      const that = this
      that.$f7.popup('.forms-page')
    },
    openToAddAttachment () {
      this.$f7.popup('#attachment-import')
    },
    openCreateAttachmentInvoice () {
      this.$f7.popup('#attachment-create-invoice')
    },
    extractCSV () {
      let that = this
      let params = {
        idAcct: this.$engine.user.get().id
      }

      // smartphoneStorage vaut true si on est sur petit écran, false sinon
      if (this.$engine.services.directPayments.filter.smartphoneStorage) {
        this.isSmartphone = true
      }
      that.$engine.attachments.getRefresh(params).then(response => {
        let cloudFiles = response.data.docs
        let firstLine = 'id;name;type\r\n'
        let lines = ''
        for (var k in cloudFiles) {
          if (cloudFiles[k].name.toLowerCase().includes(that.filterBy.toLowerCase()) &&
          ((this.service === 'Payments' && cloudFiles[k].type[0] === '0') ||
          (this.service === 'Direct Payments' && cloudFiles[k].type[0] === '1') ||
          this.service === 'Direct Debit')) {
            lines += cloudFiles[k].id + ';' + cloudFiles[k].name + ';' + this.getLabelType(cloudFiles[k].type)[1] + '\r\n'
          }
        }

        let data = firstLine + lines

        const linkSource = 'data:text/csv;charset=utf-8;base64,' + btoa(data)
        const downloadLink = document.createElement('a')
        let today = moment()
        var fileName = ''
        if (this.service === 'Direct Debit') {
          fileName = 'attachmentModularLoan' + today.unix() + '.csv'
        } else if (this.service === 'Direct Payments') {
          fileName = 'attachmentDirectPayments' + today.unix() + '.csv'
        } else {
          fileName = 'attachmentRequestToPay' + today.unix() + '.csv'
        }

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    },
    createDrafts () {
      let that = this
      let attachmentList = that.$engine.attachments.get()
      let defaultCreditorBankAccount = ''
      if (this.$engine.bankAccounts.getDefaultBankAccount().iban !== undefined) {
        defaultCreditorBankAccount = that.$engine.bankAccounts.getDefaultBankAccount().iban
      }
      let defaultNegotiationAllowedValue = this.$engine.settings.get().defaultNegotiationAllowed === '1'
      let draftArray = []
      for (let i = 0; i < attachmentList.length; i++) {
        if (that.attachmentsSelected.includes(attachmentList[i].id)) {
          draftArray.push({
            'idAccount': this.$engine.user.get().id,
            'CreditorBankAccount': defaultCreditorBankAccount,
            'CreditorIdentifier': this.$engine.user.get().identifier,
            'DebtorName': attachmentList[i].debtorName,
            'DebtorBankAccount': attachmentList[i].debtorBankAccount,
            'DebtorIdentifier': attachmentList[i].debtorEmail,
            'RemittanceInformation': attachmentList[i].remittanceInformation,
            'ImmPmtAccepted': 'false',
            'PymtNtr': 'TERM',
            'RequestedExecutionDate': attachmentList[i].paymentsDate,
            'Amount': attachmentList[i].amount,
            'ModificationAccepted': defaultNegotiationAllowedValue,
            'AttachmentId': attachmentList[i].id,
            'AttachmentName': attachmentList[i].name,
            'AttachmentReference': attachmentList[i].internalReference
          })
        }
      }
      let requestLoad = {
        'drafts': draftArray
      }
      that.$engine.drafts.create(requestLoad)
      .then(response => {
        if (response.status === 200) {
          this.$f7.modal({
            title: 'Drafts added',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.Dom7('.attachmentTaphold').removeClass('listItemSelected')
            that.attachmentsSelected = []
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    allAttachmentsCreateDrafts () {
      let that = this
      this.$f7.showPreloader('Creating drafts')
      let attachmentList = this.$engine.attachments.get()
      let defaultCreditorBankAccount = ''
      if (this.$engine.bankAccounts.getDefaultBankAccount().iban !== undefined) {
        defaultCreditorBankAccount = that.$engine.bankAccounts.getDefaultBankAccount().iban
      }
      let defaultNegotiationAllowedValue = this.$engine.settings.get().defaultNegotiationAllowed === '1'
      let draftArray = []
      for (let i = 0; i < attachmentList.length; i++) {
        draftArray.push({
          'idAccount': this.$engine.user.get().id,
          'CreditorBankAccount': defaultCreditorBankAccount,
          'CreditorIdentifier': this.$engine.user.get().identifier,
          'DebtorName': attachmentList[i].debtorName,
          'DebtorBankAccount': attachmentList[i].debtorBankAccount,
          'DebtorIdentifier': attachmentList[i].debtorEmail,
          'RemittanceInformation': attachmentList[i].remittanceInformation,
          'ImmPmtAccepted': 'false',
          'PymtNtr': 'TERM',
          'RequestedExecutionDate': attachmentList[i].paymentsDate,
          'Amount': attachmentList[i].amount,
          'ModificationAccepted': defaultNegotiationAllowedValue,
          'AttachmentId': attachmentList[i].id,
          'AttachmentName': attachmentList[i].name,
          'AttachmentReference': attachmentList[i].internalReference
        })
      }
      let requestLoad = {
        'drafts': draftArray
      }
      if (draftArray.length > 0) {
        that.$engine.drafts.create(requestLoad)
        .then(response => {
          that.$f7.hidePreloader()
          if (response.status === 200) {
            this.$f7.modal({
              title: 'Drafts added',
              text: '<span class="preloader"></span>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              that.Dom7('.attachmentTaphold').removeClass('listItemSelected')
              that.attachmentsSelected = []
            }, 2000)
          }
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
      } else {
        that.$f7.hidePreloader()
        that.$f7.alert('', 'No document', function () {
          return
        })
      }
    }
  }
}
</script>

<style scoped>
  .col-md {
    margin-right: 0%;
  }


@media (max-width: 768px) {
  .search {
    margin-top: 42px;
  }
  .toolbarPageBottomBlank {
    height: 175px !important;
  }
}

@media (min-width: 768px) and (max-width: 996px) {
  .search {
    margin-top: 35px;
  }
}
.rowBackgroundImage {
  background-image: url('../../assets/static/images/MenuFont.png');
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// CMAttachmentsPage.vue?42f8c104